import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Section } from "../models/section"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class SectionService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'section/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllSections(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<Section>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllSections?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
 
  viewSection(SectionID?: string): Observable<Array<Section>> {
    return this.httpService.get(this.apiEndpoint + 'viewSection/' + (SectionID ? SectionID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveSection(locations: Section): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveSection/', locations).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  deleteSection(SectionID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteSection/' + (SectionID ? SectionID : '00000000-0000-0000-0000-000000000000'), SectionID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(SectionName?: string,SectionId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?SectionName=' + (SectionName ? SectionName : '')+ '&SectionId=' + (SectionId ? SectionId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        return result; 
    }));
  }
}
